@if (isOpen() && chat()) {
  <div
    class="modal-backdrop"
    (click)="close()"
  >
    <div
      class="modal-content"
      (click)="$event.stopPropagation()"
    >
      <div class="modal-header">
        <h2>{{ translateService.getTranslation(4144) }}</h2>
        <button
          class="close-btn"
          (click)="close()"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="info-row">
          <strong>{{ translateService.getTranslation(4141) }}:</strong>
          <span>{{ chat()!.name }}</span>
        </div>

        <div class="participants-section">
          <div class="participants-label">
            <span class="material-symbols-outlined">group</span>
            <strong>{{ translateService.getTranslation(4142) }}</strong>
          </div>
          <div class="participant-chips">
            @for (p of chat()!.participants; track p.id) {
              <span class="chip">{{ p.userName }}</span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
